<template>
    <div v-if="loaded">
        <form class="signup_form" @submit.prevent="$emit('next', formData)">
        <ul>
            <div class="part">
                <li>
                    <label>סוג ייצוג</label>
                    <wzMultiSelect v-model="formData.representation_type" :settings="{ width: '100%', val: 'name', key: 'id', theme: 'light'}" :options="$store.representation_type" v-if="$store.representation_type.length > 0"/>

                    <!-- <select v-model="formData.representation_type" >
                        <option value="">בחירה מתוך הרשימה</option>
                        <option v-for="item in rep_list" :key="item.id" :value="item.id" >{{ item.name }}</option>
                    </select> -->
                </li>
                <li>
                    <label>אזורי פעילות בארץ</label>
                    <wzMultiSelect v-model="formData.activity_areas_country" :settings="{ width: '100%', val: 'name', key: 'id', theme: 'light'}" :options="$store.activity_areas_country" v-if="$store.activity_areas_country.length > 0"/>
                    <!-- <select v-model="formData.activity_areas_country" >
                        <option value="">בחירה מתוך הרשימה</option>
                        <option v-for="item in list" :key="item.id" :value="item.id" >{{ item.name }}</option>
                    </select> -->
                </li>
                <li>
                    <label>מספר עורכי הדין במשרד</label>
                    <input type="number" min="0" v-model="formData.num_lawyers_per_office" >
                </li>
                <li>
                    <label>אודות המשרד</label>
                    <textarea v-model="formData.about_company" ></textarea>
                </li>
                <li>
                    <label>לוגו המשרד</label>
                    <!-- <a class="btn_b">
                        <span>העלאת קובץ</span>
                        <span class="upload_icon icon"></span>
                    </a> -->
                    <GalleryInput  :max="1" v-model="formData.company_logo" @onUpload="formData.company_logo =  $event.id"/>
                    <span class="helper_text">מומלץ להעלות קובץ בגודל מינימלי של 300X200 פיקסלים</span>
                </li>
            </div>
            <input v-if="state != 'edit'" type="submit" class="btn" value="המשך">
        </ul>
        </form>
    </div>
</template>

<script>
import GalleryInput from '../GalleryInput.vue';
import WzMultiSelect from '../wzMultiSelect.vue';

export default {
    props: ["updatedData", "state"],
    components: {GalleryInput, WzMultiSelect},
    data() {
        return {
            rep_list:[],
            loaded:false,
            list:[],
            formData: {
                representation_type: '',
                activity_areas_country: '',
                num_lawyers_per_office: '',
                about_company: '',
                company_logo: '',
                step: 3
            }
        }
    },
    mounted() {
        this.init();

       
    },
    methods: {
        init() {
            if (this.updatedData) {
                for (const key in this.formData) {
                    if (this.updatedData[key]) this.formData[key] = this.updatedData[key];
                }
            }
            this.loaded = true;
        }
    },
    watch: {
        formData: {
            handler: function (val) {
                this.$emit('update', val)
            },
            deep: true
        },
        updatedData() {
        // this.init()

        }
    },
}
</script>

<style>

</style>